//export const config = { apiUrl: 'localhost:4000/api' }   
export const config = (process.env.NODE_ENV === 'development') ?
    require('./config.dev.json')
    : require('./config.prod.json');
